<template>
  <div class="pop">
    <div class="exceladd">
      <div class="title">题库导入</div>
      <div class="main">
        <div class="tab">
          <!-- <span @click="tab=0" :class="{active:tab==0}">题库导入</span>
          <span @click="tochosed" :class="{active:tab==1}">已选择的</span>-->
          <RadioGroup @on-change="tabchanged" v-model="tab" type="button">
            <Radio :label="0">题库导入</Radio>
            <Radio :label="1">已选择的</Radio>
          </RadioGroup>
        </div>
        <div v-show="tab==0">
          <div class="search">
            <div class="search_item">
              <div class="item">
                <span>题目名称：</span>
                <Input v-model="data.question" placeholder="请输入..." style="width:150px"/>
              </div>
              <span>
                难易度：
                <Select v-model="data.questionlevel" style="width:100px">
                  <Option value="all">全部</Option>
                  <Option :value="1">易</Option>
                  <Option :value="2">中</Option>
                  <Option :value="3">难</Option>
                </Select>
              </span>
              <span>
                题目类型：
                <Select v-model="data.questiontype" style="width:100px">
                  <Option value="all">全部</Option>
                  <Option :value="1">单选题</Option>
                  <Option :value="2">多选题</Option>
                  <Option :value="3">判断题</Option>
                  <Option :value="4">填空题</Option>
                  <Option :value="5">问答题</Option>
                </Select>
              </span>
              <span>
                所属分类：
                <Cascader
                  style="width:150px;display:inline-block"
                  :data="questiontype"
                  v-model="questionbasic"
                ></Cascader>
              </span>
              <span>
                知识点：
                <Select
                  v-model="data.questionpoint"
                  filterable
                  style="width:150px;display:inline-block"
                >
                  <Option value="all">全部</Option>
                  <Option
                    v-for="item in qplist"
                    :key="item.qpid"
                    :value="item.qpid"
                  >{{item.qptitle}}</Option>
                </Select>
              </span>
              <div class="item">
                <div class="button" @click="changepage(1)">搜索</div>
              </div>
            </div>
          </div>
          <div class="table">
            <CheckboxGroup v-model="value">
              <div style="margin-right:15px;">
                <table>
                  <thead>
                    <tr>
                      <td style="width:50px;">编号</td>
                      <td style="width:200px;">题目名称</td>
                      <td style="width:50px;">所属分类</td>
                      <td style="width:50px;">题目类型</td>
                      <td style="width:100px;">知识点</td>
                      <td style="width:50px;">分值</td>
                      <td style="width:50px;">难度</td>
                      <!-- <td>添加时间</td> -->
                    </tr>
                  </thead>
                </table>
              </div>
              <div class="tbody">
                <table>
                  <tbody>
                    <tr v-for="item in list" :key="item.questionid">
                      <td style="width:50px;">
                        <Checkbox :label="item.questionid" :disabled="item.used"></Checkbox>
                      </td>
                      <td style="width:200px;text-align:left;">{{item.question|toText}}</td>
                      <td style="width:50px;">{{item.qbtitle}}</td>
                      <td style="width:50px;">{{item.qttitle}}</td>
                      <td style="width:100px;">{{item.qptitle}}</td>
                      <td style="width:50px;">{{item.questionscore}}</td>
                      <td style="width:50px;">{{item.questionlevel|issuetype}}</td>
                      <!-- <td>{{item.questioncreatetime|formatetime}}</td> -->
                    </tr>
                  </tbody>
                </table>
              </div>
            </CheckboxGroup>
            <div class style="text-align:right;margin:10px;">
              <div style="float:left;">
                <!-- <Checkbox @on-change="ischeckall">全选</Checkbox> -->
                <Button @click="ischeckall" type="primary">全选</Button>
              </div>
              <Page
                :total="total"
                :current='data.page'
                @on-change="changepage"
                @on-page-size-change="changesize"
                show-sizer
                show-elevator
                show-total
                :page-size-opts="[5,10, 20,50]"
              />
            </div>
          </div>
        </div>
        <div v-show="tab==1">
          <div class="search">
            <div class="search_item">
              <div class="item">
                <span>题目名称：</span>
                <Input v-model="data2.question" placeholder="请输入..." style="width:150px"/>
              </div>
              <span>
                难易度：
                <Select v-model="data2.questionlevel" style="width:100px">
                  <Option value=" ">全部</Option>
                  <Option :value="1">易</Option>
                  <Option :value="2">中</Option>
                  <Option :value="3">难</Option>
                </Select>
              </span>
              <span>
                题目类型：
                <Select v-model="data2.questiontype" style="width:100px">
                  <Option value=" ">全部</Option>
                  <Option :value="1">单选题</Option>
                  <Option :value="2">多选题</Option>
                  <Option :value="3">判断题</Option>
                  <Option :value="4">填空题</Option>
                  <Option :value="5">问答题</Option>
                </Select>
              </span>
              <span>
                所属分类：
                <Cascader
                  style="width:150px;display:inline-block"
                  :data="questiontype"
                  v-model="questionbasic2"
                ></Cascader>
              </span>
              <span>
                知识点：
                <Select v-model="data2.qptitle" filterable style="width:150px;display:inline-block">
                  <Option value=" ">全部</Option>
                  <Option
                    v-for="item in qplist"
                    :key="item.qpid"
                    :value="item.qptitle"
                  >{{item.qptitle}}</Option>
                </Select>
              </span>
              <div class="item">
                <div class="button" @click="searchlist">搜索</div>
              </div>
            </div>
          </div>
          <div class="table">
            <div style="margin-right:15px;">
              <table>
                <thead>
                  <tr>
                    <td style="width:50px;">编号</td>
                    <td style="width:200px;">题目名称</td>
                    <td style="width:50px;">所属分类</td>
                    <td style="width:50px;">题目类型</td>
                    <td style="width:100px;">知识点</td>
                    <td style="width:50px;">分值</td>
                    <td style="width:50px;">难度</td>
                    <td style="width:50px;">删除</td>
                  </tr>
                </thead>
              </table>
            </div>
            <div class="tbody">
              <table>
                <tbody>
                  <tr v-for="item in list2" :key="item.questionid">
                    <td style="width:50px;">{{item.questionid}}</td>
                    <td style="width:200px;text-align:left;">{{item.question|toText}}</td>
                    <td style="width:50px;">{{item.qbtitle}}</td>
                    <td style="width:50px;">{{item.qttitle}}</td>
                    <td style="width:100px;">{{item.qptitle}}</td>
                    <td style="width:50px;">{{item.questionscore}}</td>
                    <td style="width:50px;">{{item.questionlevel|issuetype}}</td>
                    <td style="width:50px;">
                      <Button size="small" @click="del(item.questionid)" type="warning">删除</Button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class style="text-align:right;margin:10px;">
              <Button type="warning" @click="delall()">全删</Button>
            </div>
          </div>
        </div>
      </div>
      <div>
        <Button style="margin-right:100px" @click="close">取消</Button>
        <span class="button" @click="sure">确认</span>
      </div>
    </div>
  </div>
</template> 
<script>
import { Question_index, Question_getList } from "../assets/js/api.js";
export default {
  data() {
    return {
      value: [],
      valueSet: null,
      list: [],
      list2: [],
      listdb: [],
      total: null,
      tab: 0,
      data: {
        questionid: null, //	string	true	普通参数		试题编号
        questiontype: null, //	string	true	普通参数		试题题型
        questionpoint: null,
        questionlevel: null, //	string	true	普通参数		试题难度：1简单2中等3困难
        question: null, //	string	true	普通参数		题目名称
        page: 1, //	string	true	普通参数		页码
        size: 10 //	string	true	普通参数		条数
      },
      questionbasic: [],
      questionbasic2: [],
      data2: {
        questiontype: null,
        qptitle: null,
        questionlevel: null,
        question: null
      }
    };
  },
  filters: {
    issuetype(value) {
      switch (value) {
        case 1:
          return "易";
        case 2:
          return "中";
        case 3:
          return "难";
      }
    },
    toText(description) {
      var description = description.replace(/(\n)/g, "");
      description = description.replace(/(\t)/g, "");
      description = description.replace(/(\r)/g, "");
      description = description.replace(/<\/?[^>]*>/g, "");
      description = description.replace(/\s*/g, "");
      return description;
    }
  },
  props: ["haslist"],
  computed: {
    questiontype() {
      return this.$store.state.questiontype;
    },
    qplist() {
      return this.$store.state.qplist;
    },
    classmap() {
      return this.$store.state.classmap;
    }
  },
  mounted() {
    this.valueSet = new Set();
    this.getlist();
  },
  methods: {
    close() {
      this.$emit("close");
    },
    // checkchange(data){
    //   console.log(data)
    // },
    ischeckall(data) {
      if (this.haslist) {
        var check = this.list.some(item => {
          return (
            this.haslist.indexOf(item.questionid - 0) != -1 ||
            this.haslist.indexOf(item.questionid + "") != -1
          );
        });
        if (check) {
          this.errorPlus("该页有导入试卷的题目，不能全选！");
          return;
        }
      }
      this.list.forEach(item => {
        this.value.push(item.questionid);
      });
    },
    searchlist() {
      // 搜索字段
      // data2: {
      //   questiontype: null,
      //   questionlevel: null,
      //   question: null,
      //   questionpoint:null,
      // }
      this.list2 = this.listdb
        .filter(item => {
          if (this.data2.question) {
            var reg = new RegExp(this.data2.question, "gim");
            return reg.test(item.question);
          } else {
            return true;
          }
        })
        .filter(item => {
          if (this.data2.questionlevel) {
            return this.data2.questionlevel == item.questionlevel;
          } else {
            return true;
          }
        })
        .filter(item => {
          if (this.data2.questiontype) {
            return this.data2.questiontype == item.questiontype;
          } else {
            return true;
          }
        })
        .filter(item => {
          if (this.data2.qptitle) {
            return this.data2.qptitle == item.qptitle;
          } else {
            return true;
          }
        })
        .filter(item => {
          if (this.questionbasic2.length) {
            return (
              this.classmap.get(this.questionbasic2.slice(-1)[0]) ==
              item.qbtitle
            );
          } else {
            return true;
          }
        });
    },
    changepage(data) {
      this.data.page = data;
      this.getlist();
    },
    changesize(data) {
      this.data.page = 1;
      this.data.size = data;
      this.getlist();
    },
    getlist() {
      var data={}
      for (var item in this.data) {
        if (this.data[item] == "all") {
          data[item] = " ";
        }else{
          data[item] = this.data[item]
        }
      }
      if (this.questionbasic) {
        data.questionbasic = this.questionbasic.slice(-1)[0];
      }
      this.value.forEach(item => {
        this.valueSet.add(Number(item));
      });
      Question_index(data).then(res => {
        if (res.data.code == 200) {
          this.list = res.data.data.list.map(item => {
            if (this.haslist) {
              if (
                this.haslist.indexOf(item.questionid - 0) != -1 ||
                this.haslist.indexOf(item.questionid + "") != -1
              ) {
                item.used = true;
              } else {
                item.used = false;
              }
            }
            return item;
          });
          this.total = res.data.data.count;
          return;
        }
        this.errorPlus(res.data.message);
        this.list=[]
      });
    },
    sure() {
      this.value.forEach(item => {
        this.valueSet.add(item);
      });
      Question_getList({
        questionid: Array.from(this.valueSet).toString()
      }).then(res => {
        if (res.data.code == 200) {
          this.$emit("sure", res.data.data);
        } else {
          this.$Notice.warning({
            title: "信息提示",
            desc: res.data.message
          });
        }
        this.$emit("close");
      });
    },
    tabchanged(data) {
      if (data == 0) {
        this.value = Array.from(this.valueSet);
      } else {
        this.valueSet.clear();
        this.value.forEach(item => {
          this.valueSet.add(item);
        });
        if (this.valueSet.size == 0) {
          this.$Notice.error({
            title: "错误提示",
            desc: "请您选择后再进行查看"
          });
          return;
        }
        this.tochosed();
      }
    },
    tochosed() {
      Question_getList({
        questionid: Array.from(this.valueSet).toString()
      }).then(res => {
        if (res.data.code == 200) {
          this.list2 = res.data.data;
          this.listdb = this.list2.map(item => {
            return item;
          });
        } else {
          this.$Notice.warning({
            title: "信息提示",
            desc: res.data.message
          });
        }
      });
    },
    del(data) {
      this.valueSet.delete(data);
      this.tochosed();
    },
    delall() {
      this.valueSet.clear();
      this.list2 = [];
    }
  }
};
</script>
<style lang="css" scoped>
.pop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.5);
}
.exceladd {
  width: 1000px;
  height: 620px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 0 20px 0 #ddd;
  box-sizing: border-box;
  padding: 20px 40px;
}
.title {
  line-height: 30px;
  font-size: 26px;
}
.button {
  width: 100px;
  height: 34px;
  font-size: 16px;
  background: #4a4cff;
  line-height: 34px;
  color: #fff;
  display: inline-block;
  margin: 0 10px;
  text-align: center;
  border-radius: 2px;
}
.button.none {
  background: none;
  color: #727982;
}
.down {
  width: 122px;
  height: 32px;
  background: #ffd6de;
  color: #ff245b;
  text-align: center;
  line-height: 32px;
  font-size: 14px;
  display: inline-block;
  text-decoration: none;
}
.tab {
  height: 35px;
  border-bottom: 1px solid #eee;
  line-height: 35px;
  padding: 0px 20px 0;
  box-sizing: border-box;
  text-align: left;
  color: #727982;
}
.tab span.active {
  border-bottom: 1px solid #474dff;
  color: #474dff;
}
.search_item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  text-align: left;
  font-size: 14px;
}
.table {
  font-size: 14px;
}
table {
  width: 100%;
  border-collapse: collapse;
}
.tbody {
  height: 300px;
  overflow-y: auto;
}
tr {
  height: 60px;
  border-bottom: 1px solid #eee;
}
</style>


// WEBPACK FOOTER //
// src/components/issuestock.vue